<template>
  <div class="h-100 pa-0">
    <Planos
      :selectedPlano="selectedPlano"
      :armarios="armarios"
      :planos="planosData"
      @click_plano="$emit('click_plano', $event)"
      @ver-en-arbol="$emit('ver-en-arbol', $event)"
      @ver-en-plano="$emit('ver-en-plano', $event)"
      @add-adjunto="$emit('add-adjunto',$event)"
      @ir-a-subplano="$emit('ir-a-subplano',$event)"
      @fetch="$emit('fetch')"
    />
  </div>
</template>

<script>
import Planos from "../Planos.vue";

export default {
  name: "ArmariosPlanosView",
  components: { Planos },
  props: {
    selectedPlano: { type: [Object, Number, String], default: null },
    armarios: { type: Array, default: () => [] },
    planosData: { type: Array, default: () => [] },
    
  },
};
</script>

<style scoped>
.h-100 {
  height: 100%;
}
</style>